module.exports = __webpack_public_path__ + "img/flower-plus-minus.53b7c602.svg";